<template>
    <div>
        <div v-if="approveAndPending.length>0">
            <GChart
                    type="PieChart"
                    :data="approveAndPending[0]"
                    :options="chartOptions"
            />
        </div>
        <div v-else>
            <div v-if="loading">
                <ChartPreLoader :typeChange="typeChange"></ChartPreLoader>
            </div>
            <div v-else>
                <EmptyChart></EmptyChart>
            </div>
        </div>

<!--        <GChart v-else-->
<!--                type="PieChart"-->
<!--                :data="val=='wards'|| val ==''?chartData[0]:chartData[1]"-->
<!--                :options="chartOptions"-->
<!--        />-->
    </div>

</template>
<script>
    import { GChart } from 'vue-google-charts'
    import ChartPreLoader from '@/views/charts/ChartPreLoader'
    import EmptyChart from '@/views/charts/EmptyChart'
    export default {
        components: {
            GChart,
            ChartPreLoader,
            EmptyChart
        },
        props:['val','approveAndPending','loading'],
        data () {
            return {
                // Array will be automatically processed with visualization.arrayToDataTable function
                chartData: [
                    [
                        ['Ward', 'Approved','Pending'],
                        ['১নং ওয়ার্ড ', 0,0],
                        ['২নং ওয়ার্ড ', 0,0],
                        ['৩নং ওয়ার্ড ', 0,0],
                        ['৪নং ওয়ার্ড ', 0,0],
                        ['৫নং ওয়ার্ড ', 0,0],
                        ['৬নং ওয়ার্ড ', 0,0],
                        ['৭নং ওয়ার্ড ', 0,0],
                        ['৮নং ওয়ার্ড ', 0,0],
                        ['৯নং ওয়ার্ড ', 0,0],
                        ['১০নং ওয়ার্ড ', 0,0],
                        ['১১নং ওয়ার্ড ', 0,0],
                        ['১২নং ওয়ার্ড ', 0,0],
                    ],
                    [
                        ['Month', 'Approved','Pending'],
                        ['Jan ', 0,0],
                        ['Feb ',  0,0],
                        ['March ', 0,0],
                        ['Apr ',  0,0],
                        ['May ', 0,0],
                        ['Jun ',  0,0],
                        ['July ', 0,0],
                        ['Aug ',  0,0],
                        ['Sep ',  0,0],
                        ['Oct ',  0,0],
                        ['Nov ', 0,0],
                        ['Dec ',  0,0],
                    ]

                ],
                chartOptions: {
                    'width':400,
                    'height':300,
                    Hole:0.6,
                    slices: {}
                },
                largeval:0,
                largeval_index:'',
                typeChange:'pie-chart'
            }
        },
        computed:{
        },
        watch:{
            '':'filterData'
        },
        mounted(){
            this.filterData()
        },
        methods:{
            filterData(){
                if(this.approveAndPending[0]){
                    this.approveAndPending[0].forEach((item,index)=>{
                        // console.log(item[1],this.largeval)
                        if(item[1]>this.largeval){
                            this.largeval = item[1];
                            this.largeval_index = index;
                        }
                        if(index == this.approveAndPending[0].length-1){
                            this.chartOptions.slices[this.largeval_index - 1] = {};
                            this.chartOptions.slices[this.largeval_index - 1].offset = 0.2
                        }
                    });
                }

            }
        }
    }
</script>
<!--<script>-->
<!--import { Pie } from 'vue-chartjs'-->

<!--export default {-->
<!--  extends: Pie,-->
<!--  mounted () {-->
<!--    this.renderChart({-->
<!--      labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],-->
<!--      datasets: [-->
<!--        {-->
<!--          backgroundColor: [-->
<!--            '#41B883',-->
<!--            '#E46651',-->
<!--            '#00D8FF',-->
<!--            '#DD1B16'-->
<!--          ],-->
<!--          data: [40, 20, 80, 10]-->
<!--        }-->
<!--      ]-->
<!--    }, {responsive: true, maintainAspectRatio: true})-->
<!--  }-->
<!--}-->
<!--</script>-->
